import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { REPEAT_OPTIONS } from 'components/RepeatSelect';
import { planOccurrences } from 'components/RepeatSelect/plan-occurrences';

type Props = {
  /** Gio bat dau cua lich goc — moc de tinh ra cac buoi lap. */
  startTime: moment.Moment | null | undefined;
  onPick: (dayRepeat: number) => void;
};

/**
 * Danh sach chu ky lap trong popover cua nut Repeat.
 *
 * Moi dong la mot muc tieu bam thang, khong qua select long nhau: tren tablet, mot thao tac
 * mot cham van la muc dich cua ca cai popover nay.
 *
 * Moi dong tu noi ra buoi ke tiep va tong so buoi. "4 weeks" la 28 ngay chu khong phai mot
 * thang, nen neu khong hien ngay that thi nhan vien se doan sai — va chi phat hien sau khi
 * chuoi da duoc tao.
 */
const RepeatOptions = ({ startTime, onPick }: Props) => {
  return (
    <RepeatOptionsStyled>
      <p className='rp-title'>Repeat every</p>
      <ul className='rp-list'>
        {REPEAT_OPTIONS.map(option => {
          const dates = planOccurrences(startTime, option.value);
          const next = dates[0];
          return (
            <li key={option.value}>
              <button type='button' className='rp-row' onClick={() => onPick(option.value)}>
                <span className='rp-label'>{option.label}</span>
                {next && (
                  <span className='rp-meta'>
                    next {next.format('MMM D')} · {dates.length} dates
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
      <p className='rp-note'>Times already booked are skipped.</p>
    </RepeatOptionsStyled>
  );
};

export default RepeatOptions;

const RepeatOptionsStyled = styled.div`
  width: min(320px, calc(100vw - 48px));

  .rp-title,
  .rp-note {
    margin: 0;
    font-family: Poppins;
    color: #64748B;
  }

  .rp-title {
    padding: 4px 12px 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  .rp-note {
    padding: 12px 12px 4px;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    border-top: 1px solid #EFEFEF;
  }

  .rp-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .rp-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-height: 56px;
    padding: 8px 12px;
    border: 0;
    border-top: 1px solid #EFEFEF;
    border-radius: 2px;
    background: transparent;
    text-align: left;
    cursor: pointer;
    transition: background-color 120ms cubic-bezier(0.25, 1, 0.5, 1),
      transform 120ms cubic-bezier(0.25, 1, 0.5, 1);
  }

  .rp-row:hover {
    background: #F6F6F6;
  }

  .rp-row:active {
    background: #EBEBEB;
    transform: translateY(1px);
  }

  .rp-row:focus-visible {
    outline: 2px solid #0085E7;
    outline-offset: -2px;
  }

  .rp-label {
    font-family: Poppins;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: #1D2129;
  }

  .rp-meta {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #64748B;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }

  @media (prefers-reduced-motion: reduce) {
    .rp-row {
      transition: none;
    }

    .rp-row:active {
      transform: none;
    }
  }
`;
